import React, { memo, ReactNode } from 'react';

export interface FullLayoutProps {
  children: ReactNode;
  className?: string;
  fullHeight?: boolean;
  maxContentWidth?: string | 'none';
}

export const FullLayout = memo(function FullLayout({
  children,
  className = '',
  fullHeight = true,
  maxContentWidth = '1400px'
}: FullLayoutProps) {
  const cssVarStyle = maxContentWidth !== 'none'
    ? { '--full-layout-max-content-width': maxContentWidth } as React.CSSProperties
    : undefined;

  return (
    <div
      className={`full-layout ${fullHeight ? 'full-layout--full-height' : ''} ${className}`}
      style={cssVarStyle}
    >
      <div className="full-layout-container">
        {children}
      </div>
    </div>
  );
});
